import { useEffect, useState } from 'react'
import { actions } from '../../PrintersManagementState'
import { useDispatch } from 'react-redux'
import * as S from './LocalPrinterSettings.styles'
import { useSelector } from 'src/utils/store'
import {
  Checkbox, FormControlLabel, FormGroup, Tooltip, Typography,
} from '@mui/material'
import { FulfillmentCenter } from 'src/features/types'
import SettingsIcon from '@mui/icons-material/Settings'
import CachedIcon from '@mui/icons-material/Cached'
import ModalEditPrinterSettings from '../ModalEditPrinterSettings'

interface LocalPrinterSettingsProps {
  fulfillmentCenters: FulfillmentCenter[]
  fulfillmentCenterId: number
}

export const LocalPrinterSettings = ({
  fulfillmentCenters,
  fulfillmentCenterId,
}: LocalPrinterSettingsProps) => {
  const dispatch = useDispatch()
  const { isRaspberrySoulConnected, localPrinter } = useSelector((state) => state.printersManagement)
  const [showModalSettings, setShowModalSettings] = useState(false)

  useEffect(() => {
    if (fulfillmentCenterId) {
      dispatch(actions.getLocalPrinter())
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fulfillmentCenterId])

  const getFulfillmenterCenterName = (fcId: number) => {
    const selectedFulfillmentCenter = fulfillmentCenters.find((fc) => fc.id === fcId)
    return selectedFulfillmentCenter ? selectedFulfillmentCenter.name : ''
  }

  const updateLocalPrinter = () => {
    dispatch(actions.getLocalPrinter())
  }

  return fulfillmentCenterId ? (
    <>
      <S.Container>
        <S.ContainerTitle>
          <Typography variant='h6'>IMPRESSORA LOCAL</Typography>
          <Tooltip title='ATUALIZAR IMPRESSORA LOCAL' placement='top' arrow>
            <CachedIcon
              onClick={updateLocalPrinter}
              fontSize='large'
              sx={{
                cursor: 'pointer',
                color: 'rgba(0, 0, 0, 0.54)',
              }}
              data-testid='update-printer-test-id'
            />
          </Tooltip>
          {(isRaspberrySoulConnected && localPrinter) && (
          <Tooltip title='CONFIGURAR IMPRESSORA LOCAL' placement='top' arrow>
            <SettingsIcon
              onClick={() => setShowModalSettings(true)}
              fontSize='large'
              sx={{
                cursor: 'pointer',
                color: 'rgba(0, 0, 0, 0.54)',
              }}
              data-testid='printer-settings-test-id'
            />
          </Tooltip>
          )}
        </S.ContainerTitle>
        {isRaspberrySoulConnected ? (
          localPrinter ? (
            <S.LocalPrinterInfosContainer>
              <S.LocalPrinterInfosSubContainer>
                <S.CustomTextField
                  sx={{
                    minWidth: '20rem',
                  }}
                  name='fulfillmentCenter'
                  id='fulfillmentCenter'
                  label='Fulfillment Center'
                  type='text'
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    readOnly: true,
                    'data-testid': 'fulfillment-center-test-id',
                  }}
                  value={localPrinter.fulfillmentCenterId ? getFulfillmenterCenterName(localPrinter.fulfillmentCenterId) : '-'}
                />
                <S.CustomTextField
                  sx={{
                    minWidth: '14rem',
                  }}
                  name='macAddress'
                  id='macAddress'
                  label='Endereço MAC'
                  type='text'
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    readOnly: true,
                    'data-testid': 'mac-address-test-id',
                  }}
                  value={localPrinter.macAddress}
                />
                <S.CustomTextField
                  sx={{
                    minWidth: '18rem',
                  }}
                  name='localIp'
                  id='localIp'
                  label='Endereço IP Local'
                  type='text'
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    readOnly: true,
                    'data-testid': 'local-ip-test-id',
                  }}
                  value={localPrinter.localIp}
                />
                <S.CustomTextField
                  sx={{
                    minWidth: '20rem',
                  }}
                  name='kdabraUrl'
                  id='kdabraUrl'
                  label='Kdabra URL'
                  type='text'
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    readOnly: true,
                    'data-testid': 'kdabra-url-test-id',
                  }}
                  value={localPrinter.kdabraUrl || '-'}
                  fullWidth
                />
              </S.LocalPrinterInfosSubContainer>
              <S.LocalPrinterInfosSubContainer>
                <S.CustomTextField
                  sx={{
                    minWidth: '20rem',
                  }}
                  name='deviceName'
                  id='deviceName'
                  label='Nome do Dispositivo'
                  type='text'
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    readOnly: true,
                    'data-testid': 'device-name-test-id',
                  }}
                  value={localPrinter.deviceName || '-'}
                  fullWidth
                />
                <FormGroup
                  sx={{
                    minWidth: '14rem',
                    paddingTop: '.9rem',
                  }}
                >
                  <FormControlLabel
                    control={(
                      <Checkbox
                        name='printerServer'
                        id='printerServer'
                        inputProps={{
                          'aria-label': 'printer-server',
                          'data-testid': 'printer-server-test-id',
                        } as React.InputHTMLAttributes<HTMLInputElement>}
                        checked={localPrinter.printerServer}
                        disabled
                      />
                    )}
                    label={(
                      <Typography
                        sx={{
                          width: '100%',
                          display: 'flex',
                        }}
                        variant='body1'
                      >
                        Servidor de impressão?
                      </Typography>
                    )}
                  />
                </FormGroup>
              </S.LocalPrinterInfosSubContainer>
            </S.LocalPrinterInfosContainer>
          ) : (
            <Typography variant='body1'>Impressora não identificada</Typography>
          )
        ) : (
          <Typography variant='body1'>Alma não conectada</Typography>
        )}
      </S.Container>
      {(isRaspberrySoulConnected && localPrinter) && (
        <ModalEditPrinterSettings
          show={showModalSettings}
          onClose={() => setShowModalSettings(false)}
          localPrinter={localPrinter}
          fulfillmentCenters={fulfillmentCenters}
        />
      )}
    </>
  ) : null
}
